import type { PropsWithChildren } from "react";
import { Typography } from "@/react/components/shared/uikit/Typography";

export const TabSubTitle = ({ children }: PropsWithChildren<unknown>) => (
  <Typography.BodyMd color="text-default">{children}</Typography.BodyMd>
);
